import { Typography } from '@/components'
import { Row } from '@/components/styled'
import { ThemeColor } from '@/enums'
import { Address } from '@/types/address'
import { UserProfile } from '@/types/user-profile'
import { formatRiskAddress } from '@/utils/address'
import { useTranslation } from 'react-i18next'
import { WelcomeBackMessageContainer } from '../styles'

type Props = {
  userProfileData: UserProfile | undefined
  isGenericLocation: boolean
  name: string
  address: Address | undefined
}

export const PageHeader = ({
  userProfileData,
  isGenericLocation,
  name,
  address,
}: Props) => {
  const { t } = useTranslation()
  return (
    <WelcomeBackMessageContainer>
      <Typography bold variant="footnote" color={ThemeColor.b50}>
        {t('locationPage.locationOverview')}
      </Typography>
      <Typography bold variant="h4">
        {userProfileData?.name
          ? t('welcome_text_dashboard_with_name', {
              name: userProfileData?.name,
            })
          : t('welcome_text_dashboard')}
      </Typography>
      {!isGenericLocation && address && (
        <Row alignItems="center" gap="4px">
          <Typography variant="p2Body" color={ThemeColor.b50}>
            {name} / {formatRiskAddress(address)}
          </Typography>
        </Row>
      )}
    </WelcomeBackMessageContainer>
  )
}
